module.exports = __webpack_public_path__ + "img/concept-agent-skills.dbfe95ee.svg";